import {
  LOADER,
  MODAL,
  ROOM
} from '../../reduxs'

import apiService from '../apiService'

export const clearFavourite = (param, func = () => {}) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('rest/v1/unfavourite_room', param).then(res => {
      if (res.status) {
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
      } else {
        console.log('ERROR ACTION clearFavourite', res)
      }
      dispatch(LOADER.action.displayLoader(false))
    })
  }
}
export const getlistRoom = (param, func = () => {}) => {
  return dispatch => {
      dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v1/getlist_room', param).then(res => {
      if (res.status) {
        // dispatch(saveListRoom(res.data.list))
        func(res.data)
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
      } else {
        console.log('ERROR ACTION getlistRoom', res)
      }
      dispatch(LOADER.action.displayLoader(false))
    })
  }
}

export const getRoomsV2 = (param, func = () => {}) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v2/room', param).then(res => {
      if (res.status) {
        func(res.data)
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
      }
      dispatch(LOADER.action.displayLoader(false))
    })
  }
}

export const getListBookingOfRoom = (param) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v2/getlist_booking', { ...param, showPrivateSubject: true }).then((res) => {
      // console.log(res, 'res')
      if (res.status) {
        dispatch(saveListBookingOfRoom(res.data))
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getListBookingOfRoom', res)
      }
    })
  }
}

export const getDetailRoom = (param) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v1/getdetail_room', param).then((res) => {
      if (res.status) {
        dispatch(saveDetailRoom(res.data))
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getDetailRoom', res)
      }
    })
  }
}

export const getDetailRoomV2 = (param) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get(`rest/v2/room/${param.roomId}`, { roomId: param.roomId }).then((res) => {
      if (res.status) {
        dispatch(saveDetailRoom(res.data))
      } else {
        dispatch(MODAL.action.openModalStatus(res))
      }
      dispatch(LOADER.action.displayLoader(false))
    })
  }
}

export const saveFavouriteData = (param, func = () => {}) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('rest/v1/favourite_room', param).then((res) => {
      if (res.status) {
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION saveFavourite', res)
      }
    })
  }
}

export const clearFavouriteData = (param, func = () => {}) => {
  return (dispatch) => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('rest/v1/unfavourite_room', param).then((res) => {
      if (res.status) {
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION clearFavouriteData', res)
      }
    })
  }
}

export const saveListRoom = (list) => {
  return {
    type: ROOM.actionType.SAVE_LIST_ROOM,
    list
  }
}

export const saveListBookingOfRoom = (data) => {
  return {
    type: ROOM.actionType.SAVE_LIST_BOOKING_OF_ROOM,
    data,
    pageCount: data.pageCount
  }
}

export const saveDetailRoom = (data) => {
  return {
    type: ROOM.actionType.SAVE_DETAIL_ROOM,
    data
  }
}

export const clearAllDetailRoom = () => {
  return {
    type: ROOM.actionType.CLEAR_ALL_DETAIL_ROOM
  }
}
